// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Score_wrapper__1Kvl","box":"Score_box__22z_","text":"Score_text__4Vle"};


//////////////////
// WEBPACK FOOTER
// ./src/components/util/Score/Score.scss
// module id = 1065
// module chunks = 0